import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';
import SidebarBox from 'components/SidebarBox';

import { SeoRouteSidebar_seoRoute$key } from '__generated__/SeoRouteSidebar_seoRoute.graphql';
import SeoRouteJsonParams from 'components/SeoRouteJsonParams';

type Props = {
  seoRoute: SeoRouteSidebar_seoRoute$key;
};

const SeoRouteSidebar: FC<Props> = props => {
  const seoRoute = useFragment(
    graphql`
      fragment SeoRouteSidebar_seoRoute on SeoRoute {
        jsonParams {
          name
        }

        ...EntitySidebar_entity
        ...SeoRouteJsonParams_seoRoute
      }
    `,
    props.seoRoute
  );

  return (
    <EntitySidebar entity={seoRoute}>
      {seoRoute.jsonParams.length > 0 && (
        <SidebarBox label="Parametrai:">
          <SeoRouteJsonParams seoRoute={seoRoute} />
        </SidebarBox>
      )}
    </EntitySidebar>
  );
};

export default SeoRouteSidebar;
